import { apiClient } from '@borradh-workspace/api-client';
import type {
  BusinessReport,
  ReportWindowInput,
} from '@borradh-workspace/api-client/types';
import { businessReportSchema } from '@borradh-workspace/contracts';
import { queryOptions, useQuery } from '@tanstack/react-query';

import { queryKeys } from '@/lib/query-keys';

import { reportSearchParams } from '../../lib/report-window';

export const getBusinessReportQueryOptions = (params: ReportWindowInput) =>
  queryOptions({
    queryKey: queryKeys.reports.business(
      params.from,
      params.to,
      params.locationId
    ),
    queryFn: () =>
      apiClient.get<BusinessReport>(
        `reports/business?${reportSearchParams(params)}`,
        { schema: businessReportSchema }
      ),
    staleTime: 60 * 1000,
  });

export const useGetBusinessReport = (params: ReportWindowInput) => {
  const query = useQuery(getBusinessReportQueryOptions(params));
  return {
    report: query.data ?? null,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};
